import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  loading: {},
  isFetchingArticles: null,
  disablePictureWall: false,
  currentWallID: false,
  currentWallName: "",
  cartNoStock: [],
  updated: false,
  searchQuery: '',
  price: 0,
  pictureWall: 0,
  background: false,
  pictureWallColor: {
    key: "white",
    preview: "white",
    border: "1"
  },
  currentWallField: false,
  currentWallFieldConditions: false,
  currentWallFieldSize: false,

  articleFilterActive: false,
  articleFilter: false,
  articleFilterAvailable: false,
  chosenArticleFilter: [],
  currentArticleSorting: 'all',

  chosenArticles: {},
  chosenFrames: {},

  wallPicture: false,

  leftTitle: "",
  currentPicker: "",

  hideLeftMenu: false,

  savedWallsPickerActive: false,
  highlightPictureWallItems: false,

  currentWallURL: "",

  basketID: false,
  siteBasket: {
    qty: '0',
    sum: '0',
  },

  isOwner: true

}

const mutations = {

  cartNoStock(state, data){
    Vue.set(state, 'cartNoStock', data)
  },

  sendingApiRequest(state, data){
    Vue.set(state, 'isFetchingArticles', data)
  },

  updated(state, data){
    Vue.set(state, 'updated', data)
  },

  searchQuery(state, data){
    Vue.set(state, 'searchQuery', data)
  },

  currentWallID(state, data){
    Vue.set(state, 'currentWallID', data)
    Vue.set(state, 'updated', false)
  },

  currentWallName(state, data){
    Vue.set(state, 'currentWallName', data)
  },

  startLoading(state, data){
    Vue.set(state.loading, data, true)
  },

  disablePictureWall(state, data){
    Vue.set(state, 'disablePictureWall', data)
  },

  stopLoading(state, data){
    Vue.set(state.loading, data, false)
  },

  resetLoading(state, data){
    Vue.set(state, 'loading', {})
  },

  leftPanel(state, data){
    Vue.set(state, 'leftPanel', data)
  },

  leftTitle(state, data){
     Vue.set(state, 'leftTitle', data)
  },

  currentPicker(state, data){
     Vue.set(state, 'currentPicker', data)
  },

  hideLeftMenu(state, data){
     Vue.set(state, 'hideLeftMenu', data)
  },

  articleFilterActive(state, data){
    Vue.set(state, 'articleFilterActive', data)
  },

  articleFilter(state, data){
    Vue.set(state, 'articleFilter', data)
  },

  articleFilterAvailable(state, data){
    Vue.set(state, 'articleFilterAvailable', data)
  },

  toggleChosenArticleFilter(state, data){

    // Get current filters
    let current = state.chosenArticleFilter

    let found = false;
    let position = false;

    // Create a list of items
    if(current.length)
      $.each(current, function(index, value){
        if(value.id == data.id){
          found = true
          position = index
        }
      })

    if(!found){         
      current.push(data);             
    }else{
      current.splice(position, 1);  
    }

    Vue.set(state, 'chosenArticleFilter', current)
  },

  chosenArticleFilter(state, data){
    Vue.set(state, 'chosenArticleFilter', data)
  },

  currentArticleSorting(state, data){
    Vue.set(state, 'currentArticleSorting', data)
  },

  savedWallsPickerActive(state, data){
    Vue.set(state, 'savedWallsPickerActive', data)
  },

  pictureWall(state, data){

    if(data)
      if(typeof data.articles == undefined || !data.articles)
        data.articles =  JSON.parse(data.settings)
    
    Vue.set(state, 'pictureWall', data)
    Vue.set(state, 'updated', true)
  },

  wallPicture(state, data){
    Vue.set(state, 'wallPicture', data)
  },

  background(state, data){

    // Set background
    Vue.set(state, 'background', data)
    Vue.set(state, 'updated', true)

  },

  pictureWallColor(state, data){
    Vue.set(state, 'pictureWallColor', data)
    Vue.set(state, 'updated', true)
  },

  resetPictureWallColor(state, data){
    var defaultColor = Vue.util.extend({}, window.appSettings.defaultBackground)
    Vue.set(state, 'pictureWallColor', defaultColor)
  },

  currentWallField(state, data){
    Vue.set(state, 'currentWallField', data)
  },

  currentWallFieldConditions(state, data){
    Vue.set(state, 'currentWallFieldConditions', data)
  },

  currentWallFieldSize(state, data){
    Vue.set(state, 'currentWallFieldSize', data)
  },

  chosenArticles(state, data){
    Vue.set(state, 'chosenArticles', data)
    Vue.set(state, 'updated', true)
  },

  chosenFrames(state, data){
    Vue.set(state, 'chosenFrames', data)
    Vue.set(state, 'updated', true)
  },

  highlightPictureWallItems(state, data){
    Vue.set(state, 'highlightPictureWallItems', data)
  },

  currentWallURL(state, data){
    Vue.set(state, 'currentWallURL', data)
  },

  siteBasket(state, data){
    Vue.set(state, 'siteBasket', data)
  },

  basketID(state, data){
    window.vueRender(function(){
      window.vueInstance.$localStorage.set('basketID', data);
    });
    Vue.set(state, 'basketID', data)
  },

  isOwner(state, data){
    Vue.set(state, 'isOwner', data)
  },

  initChosenArticles(state, data){

    // Chosen articles
    var chosenArticles = {}

    $.each(data, function(){
      chosenArticles[this.item] = false
    });

    // Loop each field and initialize the right keys
    Vue.set(state, 'chosenArticles', chosenArticles)

    // Chosen frames
    var chosenFrames = {}

    // The data here is the current picture wall fields
    $.each(data, function(){
      chosenFrames[this.item] = false
    });

    // Loop each field and initialize the right keys
    Vue.set(state, 'chosenFrames', chosenFrames)

  },

  resetChosenArticles(state){
   state.chosenArticles = {}
  },

  // Set price depending on chosen articles and frames
  calculatePrice(state){

    var self = this;
    var price = 0;

    if(state.pictureWall && state.pictureWall.articles){

      // Chosen articles
      $.each(state.chosenArticles, function(){

        // If something is chosen
        if(typeof(this.id) !== "undefined"){
          var currentPrice = parseFloat(this.price)

          price += currentPrice;
        }

      });

      // Chosen frames
      $.each(state.chosenFrames, function(index, value){

        // If something is chosen
        if(typeof(value) !== "undefined" && value){

          // Add to cost
          price += parseFloat(value.price);

        }

      });

    }

    Vue.set(state, 'price', price)

    // Tell that we have a new price
    window.eventHub.$emit('priceUpdated', price)

  },

  // Normal operators
  addPrice(state, data){
    state.price = state.price + data;
  },

  subtractPrice(state, data){
    state.price = state.price - data;
  },

  // Reset
  resetPrice(state, data){
     state.price = 0;
  }

}

const actions = {
  // Test
}

const store = new Vuex.Store({
  state,
  mutations,
  actions
})

export default store



// WEBPACK FOOTER //
// ./client/store/index.js